import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="print"
export default class extends Controller {
  static targets = ['content']

  print() {
    const printWindow = window.open('', 'print', 'height=800,width=1200')

    printWindow.document.write('<html><head><title>' + document.title  + '</title>')
    printWindow.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous">')
    printWindow.document.write('</head><body >')
    printWindow.document.write('<div class="card"><div class="card-body">')
    printWindow.document.write('<h5 className="card-title">' + document.title + '</h5>')
    printWindow.document.write(this.contentTarget.innerHTML)
    printWindow.document.write('</div></div>')
    printWindow.document.write('</body></html>')

    printWindow.document.close()
    printWindow.focus()

    printWindow.print()
    printWindow.close()
  }
}
